import { PropsType } from "../../lib/Props";
import { boxMixinPropsType, } from "../../mixins/box";
export const placeholderBoxPropsType = new PropsType({
    loadingView: true,
    skeleton: true,
});
export const boxPropsType = boxMixinPropsType
    .extend(placeholderBoxPropsType)
    .complete({
    role: true,
    as: true,
    breakpointClassName: true,
    classNames: true,
    key: true,
    ref: true,
    style: true,
    className: true,
    onClick: true,
    id: true,
    onMouseDown: true,
    onMouseLeave: true,
    onMouseEnter: true,
    onKeyDown: true,
    tabIndex: true,
    children: true,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Cb3gvdHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBQzVDLE9BQU8sRUFFTCxpQkFBaUIsR0FDbEIsTUFBTSxrQkFBa0IsQ0FBQztBQWMxQixNQUFNLENBQUMsTUFBTSx1QkFBdUIsR0FBRyxJQUFJLFNBQVMsQ0FBc0I7SUFDeEUsV0FBVyxFQUFFLElBQUk7SUFDakIsUUFBUSxFQUFFLElBQUk7Q0FDZixDQUFDLENBQUM7QUFtQ0gsTUFBTSxDQUFDLE1BQU0sWUFBWSxHQUFHLGlCQUFpQjtLQUMxQyxNQUFNLENBQUMsdUJBQXVCLENBQUM7S0FDL0IsUUFBUSxDQUFXO0lBQ2xCLElBQUksRUFBRSxJQUFJO0lBQ1YsRUFBRSxFQUFFLElBQUk7SUFDUixtQkFBbUIsRUFBRSxJQUFJO0lBQ3pCLFVBQVUsRUFBRSxJQUFJO0lBQ2hCLEdBQUcsRUFBRSxJQUFJO0lBQ1QsR0FBRyxFQUFFLElBQUk7SUFDVCxLQUFLLEVBQUUsSUFBSTtJQUNYLFNBQVMsRUFBRSxJQUFJO0lBQ2YsT0FBTyxFQUFFLElBQUk7SUFDYixFQUFFLEVBQUUsSUFBSTtJQUNSLFdBQVcsRUFBRSxJQUFJO0lBQ2pCLFlBQVksRUFBRSxJQUFJO0lBQ2xCLFlBQVksRUFBRSxJQUFJO0lBQ2xCLFNBQVMsRUFBRSxJQUFJO0lBQ2YsUUFBUSxFQUFFLElBQUk7SUFDZCxRQUFRLEVBQUUsSUFBSTtDQUNmLENBQUMsQ0FBQyJ9